module.exports = __webpack_public_path__ + "img/food.80d40b3a.jpg";